import type { Catalog, Product, Sku } from "../../../model/Catalog";

export const atLeastOneSkuEnabledInProduct = (product: Product): boolean => {

    for (const sku of product.skus) {
        if (!sku.disable) {
            return true;
        }
    }

    return false;
}

export const isProductAlcohol = (product: Product): boolean => {
    return !!product.is_alcohol;
}

export const getProductByProductRef = (catalog: Catalog | null, productRef?: string): Product | undefined => {
    if (!catalog || !productRef) return;
    return catalog?.data.products.find((product: Product) => {
        return product.ref === productRef
    })
}

export const getSkuBySkuRef = (product?: Product, skuRef?: string): Sku | undefined => {
    if (!product || !skuRef) return;
    return product?.skus.find((sku: Sku) => {
        return sku.ref === skuRef
    })
}